import { Component, Input } from '@angular/core';
import { VALIDATE_WORK_PLAN_STATUS_TITLES } from 'src/app/work-and-rest-user/enums/validate-work-plan-status.enum';

@Component({
  selector: 'app-work-plan-validation-template',
  standalone: false,
  templateUrl: './work-plan-validation-template.component.html',
  styleUrl: './work-plan-validation-template.component.scss',
})
export class WorkPlanValidationTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  VALIDATE_WORK_PLAN_STATUS_TITLES = VALIDATE_WORK_PLAN_STATUS_TITLES;
}
